/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Not_EmbeddedInputs */



/**
* | output |
* | --- |
* | "Not embedded" |
*
* @param {Project_References_Not_EmbeddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_not_embedded = /** @type {((inputs?: Project_References_Not_EmbeddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Not_EmbeddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht eingebettet")
	return /** @type {LocalizedString} */ ("Not embedded")
});